
export const CONFIRMED_GET_PATHYA = "CONFIRMED_GET_PATHYA"
export const CONFIRMED_CREATE_PATHYA = "CONFIRMED_CREATE_PATHYA"
export const CONFIRMED_EDIT_PATHYA = "CONFIRMED_EDIT_PATHYA"
export const CONFIRMED_DELETE_PATHYA = "CONFIRMED_DELETE_PATHYA"
